// extracted by mini-css-extract-plugin
module.exports = {"success":"#00703c","neutral":"#777","neutral200":"#c6c6c6","root":"Badge_root__N-Kiq","root--success":"Badge_root--success__1376E","rootSuccess":"Badge_root--success__1376E"};